import React from 'react';

import Accordion from '@commons/Accordion';
import Checkbox from '@commons/Checkbox';

import CookieCategoryControl from '@components/CookieBanner/V3/CookieCategoryControl';
import CookieCategoryDetails from '@components/CookieBanner/V3/CookieCategoryDetails';
import { COOKIE_CATEGORY, PANEL_ID_CATEGORY } from '@components/CookieBanner/V3/utils';
import CookieBannerPanel from '@components/CookieBanner/shared/CookieBannerPanel';

import stripHtml from '@utils/stripHtml';

interface PanelCookieSettingsProps {
  navigation: unknown;
  categories: {
    title?: string;
    message?: string;
    category?: string;
  }[];
  allSelected: boolean;
  // Actions
  onSelectAll: (...args: unknown[]) => unknown;
  onDeselectAll: (...args: unknown[]) => unknown;
  onToggleCategory: (...args: unknown[]) => unknown;
  onConfirmChoices: (...args: unknown[]) => unknown;
  // Translations
  title: string;
  confirmText: string;
  cookieDetailsText: string;
  selectAllCookiesText: string;
  requiredText: string;
}

const PanelCookieSettings = ({
  navigation,
  categories,
  allSelected,

  // Actions
  onSelectAll,

  onDeselectAll,
  onToggleCategory,
  onConfirmChoices,

  // Translations
  title,

  confirmText,
  cookieDetailsText,
  selectAllCookiesText,
  requiredText
}: PanelCookieSettingsProps) => {
  const handleSelectAll = () => {
    if (allSelected) {
      onDeselectAll();
    } else {
      onSelectAll();
    }
  };

  return (
    <CookieBannerPanel.Root>
      <CookieBannerPanel.Title>{title}</CookieBannerPanel.Title>
      <CookieBannerPanel.Section isRow noMargin>
        <Checkbox id="checkbox-all-cookies" checked={allSelected} onChange={handleSelectAll}>
          <span dangerouslySetInnerHTML={{ __html: selectAllCookiesText }} />
        </Checkbox>
      </CookieBannerPanel.Section>

      <CookieBannerPanel.Section>
        <Accordion.Root>
          {categories.map((category) => (
            <Accordion.Tab
              key={category.categoryType}
              id={category.categoryType}
              title={category.title}
              secondaryTitle={
                <CookieCategoryControl
                  id={category.categoryType}
                  value={category.consent}
                  onChange={onToggleCategory}
                  disabled={category.categoryType === COOKIE_CATEGORY.TECHNICALLY_NECESSARY}
                  requiredLabel={stripHtml(requiredText)}
                />
              }
              navigation={navigation}
              toggleButtonId={PANEL_ID_CATEGORY[category.categoryType]}>
              <CookieCategoryDetails
                category={PANEL_ID_CATEGORY[category.categoryType]}
                navigation={navigation}
                linkText={cookieDetailsText}>
                <span dangerouslySetInnerHTML={{ __html: `${category.message}` }} />
              </CookieCategoryDetails>
            </Accordion.Tab>
          ))}
        </Accordion.Root>
      </CookieBannerPanel.Section>

      <CookieBannerPanel.ActionArea>
        <CookieBannerPanel.Action full onClick={onConfirmChoices}>
          <span dangerouslySetInnerHTML={{ __html: confirmText }} />
        </CookieBannerPanel.Action>
      </CookieBannerPanel.ActionArea>
    </CookieBannerPanel.Root>
  );
};

export default PanelCookieSettings;
